import React, {useState} from 'react';
import '../App.css';
import {
    Row,
    Col,
    Progress
} from 'bootstrap-4-react';
import workBand from '../workBand.png'
import clock from '../clock.svg'

function WorkSpeedRow() {

    const initialTime = {
        auto: 250 / 31.25.toFixed(1),
        manual: 250 / 10.42.toFixed(1)
    }
    const [sqr, setSqr] = useState('250')
    const [autoWork, setAutoWork] = useState(initialTime.auto)
    const [manualWork, setManualWork] = useState(initialTime.manual)

    const calc = (event) => {
        const sqr = event.target.value
        setSqr(sqr)

        const autoWorkTime = sqr / 31.25
        const manualWorkTime = sqr / 10.42
        setAutoWork(Number(autoWorkTime.toFixed(1)))
        setManualWork(Number(manualWorkTime.toFixed(1)))

    }

    return (
        <Row id="speedRow" className={'programItem'}>
            <Col col="md-4">
                <h2 className="subtitle rowSubtitle">Как уменьшить сроки нанесения в три раза</h2>
                <p>Мы добились производительности <strong>250&nbsp;м<sup>2</sup></strong> в смену для бригады из трех человек и
                    расскажем, как этого добиться вам</p>
                <Row>
                    <Col>
                        <img src={workBand} alt={'workband'} height={120}/>
                    </Col>
                    <Col>
                        <div className={'smallText'}>Рассчитайте сроки механизированного нанесения для одной бригады, потянув за
                            слайдер:</div>
                    </Col>
                </Row>

            </Col>
            <Col col="md-8">
                <Row>
                    <Col col={'md-10'}>
                        <p>Площадь поверхностей под нанесение:</p>
                        <input onChange={(event) => calc(event)} type={'range'} min="10.0" value={sqr} max="500.0"
                               step="10"/>
                    </Col>
                    <Col col={'md-2'}>
                        <br/>
                        <h3><strong>{sqr}</strong> м<sup>2</sup></h3>
                    </Col>
                </Row>
                <Row style={{marginTop: '2em'}}>
                    <Col col={'md-10'}>
                        <p>Сроки механизированного нанесения {sqr} м<sup>2</sup>:</p>
                        <Progress style={{height: '60px'}}>
                            <Progress.Bar bg="danger" striped animated min="0" max="48"
                                          now={autoWork.toFixed(1)}>{autoWork.toFixed(1)} ч.</Progress.Bar>
                            <div className={'timeToNewObjects'}
                                 style={{display: autoWork > 10 ? 'block' : 'none'}}>Время для новых объектов
                            </div>
                        </Progress>
                    </Col>
                    <Col col={'md-2'}>

                        <div className={'workTime'} id={'autoWorkTime'}>
                            <img src={clock} alt={'clock'} height={20} />&nbsp;<strong>{autoWork.toFixed(0)}</strong><small>&nbsp;ч.</small>
                        </div>

                    </Col>
                </Row>
                <Row style={{marginTop: '2em'}}>
                    <Col col={'md-10'}>
                        <p>Сроки ручного нанесения {sqr} м<sup>2</sup>:</p>
                        <Progress style={{height: '60px'}}>
                            <Progress.Bar min="0" max="48" style={{backgroundColor: '#7d5887'}}
                                          now={manualWork.toFixed(1)}>{manualWork.toFixed(1)} ч.</Progress.Bar>
                        </Progress>
                    </Col>
                    <Col col={'md-2'}>

                        <div className={'workTime'} id={'manualWorkTime'}>
                            <img src={clock} alt={'clock'} height={20} />&nbsp;<strong>{manualWork.toFixed(0)}</strong><small>&nbsp;ч.</small>
                        </div>

                    </Col>
                </Row>


            </Col>
        </Row>


    );
}

export default WorkSpeedRow;
